import {
  Filter
} from '../common/filter';

export class FilterResource {
  constructor(
    $http,
    $q,
  ) {
    this.$http = $http;
    this.$q = $q;
  }

  // Delete saved filter (ID should be set)
  delete(filter) {
    return this.$http.post('/analytics/filter/delete/', {
        id: filter.id
      })
      .then(({
        data,
        status
      }) => {
        return {
          data,
          status
        };
      })
      .catch(({
        data,
        status
      }) => {
        new Error('HTTP error: ' + status);
      });
  }

  // Save filter to server, get ID
  save(filter, callback) {
    const filterData = Object.assign({}, filter);
    filterData.content_type = filter.content_type;
    filterData.category = filter.category;
    delete filterData.isNodeOpen;
    return this.$http.post('/analytics/filter/save/', filterData)
      .then(({
        data,
        status
      }) => {
        filter.saved = true;
        filter.isChanged = false;
        filter.id = data.id;
        if (!filter.children || !filter.children.length) filter.children = data.children;
        else data.children = filter.children;
        callback && callback(status, filter, null);
        return {
          data,
          status
        };
      })
      .catch(({
        data,
        status
      }) => {
        if (status === 422) {
          callback && callback(status, data, null);
        } else {
          callback && callback(status, data, new Error('HTTP error: ' + status));
        }
      });
  }

  // id: position.id,
  // prev_id: position.prev_id,
  // parent_id: position.parent_id,
  changePosition(id, prev_id, parent_id) {
    return this.$http.post('/analytics/filter/update_position/', {
      id,
      prev_id,
      parent_id
    });
  }

  // Return list of all filters
  list() {
    return this.$http.get('/analytics/filter/list/', {})
      .then(({
        data
      }) => {
        const result = data.map((f) => {
          f.timeTo = null;
          f.timeFrom = f.timeTo;
          f.record_count = 0;
          // f = Object.setPrototypeOf(f, Filter.prototype);
          Object.setPrototypeOf(f, Filter.prototype);
          f.typize();
          return f;
        });
        return result;
      })
      .catch(({
        status
      }) => {
        new Error('HTTP error: ' + status);
      });
  }
}



// WEBPACK FOOTER //
// ./src/core/filter-resource.service.js